module.exports = __webpack_public_path__ + "static/media/top-cut.fbf654ff.svg";